import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Megapack Estimulación Temprana'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48185772966058:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48185777684650:1'
  };
  const ctaLabels: Record<Plan, string> = {
    megapack: '→ SÍ, QUIERO EL MEGAPACK ESTIMULACIÓN TEMPRANA',
    'megapack-pro': '→ SÍ, QUIERO EL MEGAPACK + MÉTODO INTEGRAL'
  };
  return <section id="pricing" className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-184">
      <div className="mx-auto max-w-3xl" data-id="element-185">
        {/* Heading */}
        <h2 className="font-black text-center text-gray-900 m-0 mb-2 text-[25px]" data-id="element-186">
          Elegí tu{' '}
          <span className="text-cyan-brand" data-id="element-187">
            Megapack Estimulación Temprana:
          </span>
        </h2>
        <p className="text-center text-gray-500 m-0 mb-8 text-[12px]" data-id="element-188">
          Las dos opciones incluyen los 6 bonos estratégicos completos
        </p>

        {/* Plan Options */}
        <div className="mb-6 mx-auto max-w-2xl" data-id="element-189">

          {/* Option 1 — MEGAPACK ESTIMULACIÓN TEMPRANA */}
          <button onClick={() => setSelected('megapack')} className={`w-full text-left transition-all rounded-xl p-4 cursor-pointer shadow-sm ${selected === 'megapack' ? 'border-2 border-cyan-brand' : 'border border-gray-200'}`} style={{
          backgroundColor: 'rgb(255, 255, 255)'
        }} data-id="element-190">
            <div className="flex flex-row items-center gap-3" data-id="element-191">
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-192">
                {/* Radio */}
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${selected === 'megapack' ? 'border-cyan-brand' : 'border-gray-300'}`} data-id="element-193">
                  {selected === 'megapack' && <div className="h-2.5 w-2.5 bg-cyan-brand rounded-full" data-id="element-194" />}
                </div>

                {/* Info */}
                <div className="min-w-0 flex-1" data-id="element-195">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-196">
                    <span className="text-sm sm:text-base" data-id="element-197">👶</span>
                    <span className="text-sm sm:text-base font-black text-gray-900" data-id="element-198">
                      MEGAPACK ESTIMULACIÓN TEMPRANA
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 mb-0" data-id="element-199">
                    6 tomos + 6 bonos • 0 a 36 meses completo
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="shrink-0 text-right" data-id="element-200">
                <div className="text-xs text-gray-500 line-through" data-id="element-201">
                  $58.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-gray-900" data-id="element-202">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* Option 2 — MEGAPACK + MÉTODO INTEGRAL */}
          <button onClick={() => setSelected('megapack-pro')} className={`w-full text-left transition-all rounded-xl p-4 mt-3 cursor-pointer shadow-sm ${selected === 'megapack-pro' ? 'border-2 border-cyan-brand' : 'border border-gray-200'}`} style={{
          backgroundColor: 'rgb(240, 249, 255)',
          boxShadow: selected === 'megapack-pro' ? 'rgba(0, 180, 216, 0.15) 0px 0px 30px 0px' : 'none'
        }} data-id="element-203">
            <div className="flex gap-3 flex-row items-center justify-end" data-id="element-204">
              <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-205">
                {/* Radio */}
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 mt-0.5 ${selected === 'megapack-pro' ? 'border-cyan-brand' : 'border-gray-300'}`} data-id="element-206">
                  {selected === 'megapack-pro' && <div className="h-2.5 w-2.5 bg-cyan-brand rounded-full" data-id="element-207" />}
                </div>

                {/* Info */}
                <div className="min-w-0 flex-1" data-id="element-208">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-209">
                    <span className="text-sm sm:text-base" data-id="element-210">🏆</span>
                    <span className="text-sm sm:text-base font-black text-gray-900" data-id="element-211">
                      MEGAPACK + MÉTODO INTEGRAL
                    </span>
                  </div>
                  <div className="mt-1.5 flex flex-wrap items-center gap-1.5" data-id="element-212">
                    <span className="bg-cyan-brand text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-213">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-cyan-brand/10 text-[10px] font-bold text-cyan-brand border border-cyan-brand/30 rounded-full px-2 py-0.5" data-id="element-214">
                      AHORRÁS $25.000
                    </span>
                  </div>
                  <p className="text-xs text-gray-600 mt-1.5 mb-0" data-id="element-215">
                    6 tomos + 6 bonos + Método Integral™ (gestión de
                    pacientes, cobros, contratos, informes y negocio).
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="shrink-0 text-right" data-id="element-216">
                <div className="text-xs text-gray-500 line-through" data-id="element-217">
                  $102.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-cyan-brand" data-id="element-218">
                  $27.990
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA Button */}
        <div className="mx-auto max-w-2xl" data-id="element-219">
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack + Método Integral' : 'Megapack Estimulación Temprana',
          content_category: 'Estimulación Temprana',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full bg-cyan-brand text-white text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline transition-colors animate-pulse-green will-change-transform" data-id="element-220">
            {ctaLabels[selected]}
          </a>

          <p className="text-center text-xs italic text-gray-500 mt-3 mb-0" data-id="element-221">
            La más elegida por profesionales que quieren planificar con criterio
            y cobrar lo que merecen
          </p>

          {/* Trust Badges */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-600 rounded-lg px-4 py-3 shadow-sm" style={{
          backgroundColor: 'rgb(255, 255, 255)',
          border: '1px solid rgba(0, 180, 216, 0.2)'
        }} data-id="element-222">
            <span data-id="element-223">🔒 Pago seguro</span>
            <span data-id="element-224">⚡ Acceso en 5 min</span>
            <span data-id="element-225">🛡️ Garantía 7 días</span>
            <span data-id="element-226">💳 Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}